module.exports = __webpack_public_path__ + "img/Group-223.a18cce99.svg";